import React, {Component} from 'react'
import { connect } from 'react-redux'

// Actions
import { getNotificationInformation, saveNotificationInformation } from '../../../actions/settings'

// Components
import Row from '../../../shared/elements/row'
import Col from '../../../shared/elements/col'
import Panel from '../../../shared/elements/panel'
import Textarea from '../../../shared/elements/textarea'

// Utils
import { translation } from '../../../utils/helpers'

import './chainnotification.scss'

class ChainNotification extends Component {

  constructor (props) {
    super(props)
    this.state = {
      Notification: {
        ChainNotification: ''
      }
    }

    this.getSettings = this.getSettings.bind(this)
    this.updateSettings = this.updateSettings.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount () {
    this.getSettings()
  }

  getSettings () {
    this.props.getNotificationInformation().then((res) => {
      this.setState({
        Notification: res.data
      })
    }, (err) => {
      console.log('err', err.response.data)
    })
  }

  updateSettings () {
    this.props.saveNotificationInformation(this.state.Notification).then((res) => {
      this.setState({
        Notification: res.data
      }, () => {
        // window.toastr.success(translation('2215'), translation('13424'))
      })
    }, (err) => {
      console.log('err', err.response.data)
      window.toastr.error(translation('2216'), translation('216'))
    })
  }

  onChange (e) {
    e.preventDefault()
    let settings = {...this.state.Notification}
    if (e.target.name === 'ChainNotification') {
      settings.ChainNotification = e.target.value
      this.setState({
        Notification: settings
      })
    }
  }

  render () {
    let settings = {...this.state.Notification}

    const onBlur = (e) => {
      e.preventDefault()
      this.updateSettings()
    }

    return (
      <Row>
        <Col span={2}>
          <Panel title={translation('2214')}>
            <Textarea size='l' name='ChainNotification' onChange={this.onChange} value={settings.ChainNotification} onBlur={onBlur} labelText={translation('2214')} helpText={translation('2217')} />
          </Panel>
        </Col>
      </Row>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getNotificationInformation,
  saveNotificationInformation
})(ChainNotification)




// WEBPACK FOOTER //
// ./src/app/pages/Settings/ChainNotification/index.js